import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { AuthGuardGuard } from './guards/auth-guard.guard';
import { ConfigService } from 'src/services/config.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { Title } from "@angular/platform-browser";
import { AuthServiceService } from 'src/services/auth-service.service';
import { PluginsModule } from './plugins/plugins.module';
import { NotFoundComponent } from './not-found/not-found.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { ChartsModule } from 'ng2-charts';
import { ConfigurationResolver } from './resolver/configuration.resolver';

export const configFactory = (configService: ConfigService) => {
  return () => configService.loadConfig();
}


@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgxDaterangepickerMd.forRoot(),
    PluginsModule,
    ChartsModule
  ],
  providers: [
    ConfigurationResolver,
    {
      provide: APP_INITIALIZER,
      useFactory: configFactory,
      deps: [ConfigService],
      multi: true
    },
     Title,
    {
      provide: AuthGuardGuard,
      useClass: AuthGuardGuard
    },
    AuthServiceService],
  bootstrap: [AppComponent]
})
export class AppModule { }
